import React, { useState, useRef } from 'react';

import { motion, useInView } from 'framer-motion';

import { ExternalLink, Github } from 'lucide-react';



interface Project {

  id: string;

  title: string;

  description: string;

  tech: string[];

  link?: string;

  github?: string;

  image?: string;

  video?: string;

}



const projectsData: Project[] = [

    {

        id: 'Social-Media',

        title: 'Social Media app',

        description: 'A modern social media platform inspired by TikTok, Instagram, Snapchat, X, featuring AI-powered picture generations and leaderboard, and a sleek modern user interface.',

        tech: ['React', 'TypeScript', 'AI'],

        link: 'https://x.com/fanofaliens/status/1948411444925505679',

        video: 'videos/nexus.mp4',

      },

      {

        id: 'llm-detector',

        title: 'LLM Fake News Detector',

        description: 'Advanced machine learning system that identifies misinformation using transformer models and natural language processing by using Open source LLMs.Also searches the web for more context.',

        tech: ['Python', 'PyTorch', 'Transformers'],

        video: 'videos/llm-detector-demo.mp4.mp4',

      },

      {

        id: 'threejs-sim',

        title: 'THREE.js Physics Simulation',

        description: 'Interactive 3D physics playground with realistic particle systems, fluid dynamics, and gravitational effects. Also simulated a black hole.',

        tech: ['THREE.js', 'TypeScript', 'WebGL'],

        link: 'https://x.com/fanofaliens/status/1915664028157759879', 

      },

      {

        id: 'mechazilla-game',

        title: 'Mechazilla.io Game',

        description: 'Inspired by SpaceX, Mechazilla.io. I tried to build this from scratch in a single file. The rocket can be controlled to land and is interactive. I got to the point where the rocket could AI assist itself in Landing.',

        tech: ['HTML', 'CSS', 'Node.js'],

        link: 'https://x.com/fanofaliens/status/1897246679835009115', 

        video: 'videos/mechazilla.mp4',

      },

      {

        id: 'ai-art',

        title: 'AI Art Generator',

        description: 'IT requires a lot of compute so disbanded it',

        tech: ['Python', 'Pytorch', 'StyleGAN'],

        image: '/images/nebula.png',

      },

      {

        id: 'data-viz',

        title: 'Agentic AI',

        description: 'Currently working on it. Improving . Trying to make it into a Chrome Extension',

        tech: [],

        image: '/images/agentic.png',

        video: 'videos/ai_agent.mp4',

      },

      {

        id: 'autonomous-car-rl',

        title: 'Autonomous Car with RL',

        description: 'Training a car to become autonomous using Reinforcement Learning with Deep Q-Networks (DQN) in the CARLA simulation environment.',

        tech: ['Python', 'Reinforcement Learning', 'DQN', 'CARLA', 'PyTorch'],

        video: 'videos/Video Project 27.mp4',

      },

];



const ProjectCard: React.FC<{ project: Project }> = ({ project }) => {
  const videoRef = useRef<HTMLVideoElement>(null);
  const [isPlaying, setIsPlaying] = useState(false);



  const handleMediaClick = () => {
    if (project.video && videoRef.current) {
      const video = videoRef.current;
      
      if (!isPlaying) {
        // Start playing and go fullscreen
        if (video.requestFullscreen) {
          video.requestFullscreen().then(() => {
            video.play();
            setIsPlaying(true);
          }).catch(err => {
            console.error('Error attempting to enable fullscreen:', err);
            // Fallback: just play without fullscreen
            video.play();
            setIsPlaying(true);
          });
        } else {
          // Fallback: just play without fullscreen
          video.play();
          setIsPlaying(true);
        }
      } else {
        // Pause the video
        video.pause();
        setIsPlaying(false);
      }
    }
  };



  const ref = useRef(null);

  const isInView = useInView(ref, { once: true, amount: 0.2 });



  return (

    <motion.div

      ref={ref}

      initial={{ opacity: 0, y: 50 }}

      animate={isInView ? { opacity: 1, y: 0 } : {}}

      transition={{ duration: 0.8, ease: [0.16, 1, 0.3, 1] }}

      className="grid grid-cols-1 md:grid-cols-5 gap-8 items-center border-b border-[var(--color-border)] py-12"

    >

      <div className="md:col-span-3">

        <h3 className="font-display text-4xl md:text-5xl font-bold text-[var(--color-foreground)] mb-4 tracking-tight">{project.title}</h3>

        <p className="text-[var(--color-muted)] mb-6 max-w-2xl">{project.description}</p>

        <div className="flex flex-wrap gap-3 items-center">

          {project.tech.map((tech, i) => (

            <span key={i} className="text-sm text-[var(--color-muted)] border border-[var(--color-border)] px-3 py-1 rounded-full">

              {tech}

            </span>

          ))}

          <div className="flex gap-3 ml-auto">

            {project.github && 

              <a href={project.github} target="_blank" rel="noopener noreferrer" className="text-[var(--color-muted)] hover:text-[var(--color-foreground)] transition-colors">

                <Github size={20} />

              </a>

            }

            {project.link && 

              <a href={project.link} target="_blank" rel="noopener noreferrer" className="text-[var(--color-muted)] hover:text-[var(--color-foreground)] transition-colors">

                <ExternalLink size={20} />

              </a>

            }

          </div>

        </div>

      </div>

      <div className="md:col-span-2 w-full h-full overflow-hidden rounded-lg border border-[var(--color-border)] cursor-pointer" onClick={handleMediaClick}>

        {project.video ? (

          <video

            ref={videoRef}

            src={project.video}

            className="w-full h-full object-cover"

            loop

            muted

            playsInline

          />

        ) : (

          <img

            src={project.image}

            alt={project.title}

            className="w-full h-full object-cover"

          />

        )}

      </div>

    </motion.div>

  );

};



const Projects = () => {

  return (

    <div className="max-w-6xl mx-auto">

      {projectsData.map((project) => (

        <ProjectCard key={project.id} project={project} />

      ))}

    </div>

  );

};



export default Projects;

